import transactionsEn from './en/transactions.json';
import commonEn from './en/common.json';
import learnMoreEn from './en/learnMore.json';
import mockServicesEn from './en/mockServices.json';
import transactionsDropzoneEn from './en/transactionsDropzone.json';
import learnMoreDropzoneEn from './en/learnmoreDropzone.json';
import marFilesEn from './en/marFiles.json';
import vseImportEn from './en/vseImport.json';
import analyticsEn from './en/analytics.json';
import environmentsEn from './en/environments.json';
import dataSettingsEn from './en/dataSettings.json';
import wizardEn from './en/wizard.json';
import certificatesEn from './en/certificates.json';
import configurationsEn from './en/configurations.json';
import groupsEn from './en/groups.json';
import recordingsEn from './en/recordings.json';
import adminEn from './en/admin.json';
import blueprintsEn from './en/blueprints.json';

export default {
  en: {
    common: commonEn,
    learnMore: learnMoreEn,
    mockServices: mockServicesEn,
    transactions: transactionsEn,
    transactionsDropzone: transactionsDropzoneEn,
    learnMoreDropzone: learnMoreDropzoneEn,
    marFiles: marFilesEn,
    vseImport: vseImportEn,
    analytics: analyticsEn,
    environments: environmentsEn,
    dataSettings: dataSettingsEn,
    wizard: wizardEn,
    certificates: certificatesEn,
    configurations: configurationsEn,
    groups: groupsEn,
    recordings: recordingsEn,
    admin: adminEn,
    blueprints: blueprintsEn,
  },
  // add more languages here
};
